export const INITIAL_BROKER_SELECTION = '';

export async function reserveSelectedBroker(brokerName, reserveProxyBinding) {
  const selectedBroker = String(brokerName || '').trim();
  if (!selectedBroker) return null;
  return reserveProxyBinding(selectedBroker.toUpperCase());
}
